import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=4fe03f21&scoped=true&"
import script from "./Video.vue?vue&type=script&lang=js&"
export * from "./Video.vue?vue&type=script&lang=js&"
import style0 from "./Video.vue?vue&type=style&index=0&id=4fe03f21&lang=scss&scoped=true&"
import style1 from "./Video.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe03f21",
  null
  
)

export default component.exports